<script setup lang="ts">
const { smAndDown: mobile } = useDisplay()
const { impersonate } = useSession()
const { impersonating } = storeToRefs(useSession())

// Seeded rather than null: when the drawer picks its own state it emits while
// mounting, and NavLeft's render ended up with no reactive deps afterwards
// (Vue 3.5.13), so the collapse toggle stopped doing anything.
const drawer = ref(!mobile.value)
</script>

<template>
  <NavLeft v-model="drawer" />
  <v-app-bar v-if="mobile" density="compact" flat border="b">
    <v-app-bar-nav-icon aria-label="Open menu" @click="drawer = !drawer" />
    <NuxtLink to="/" class="d-flex" aria-label="SATO48 Festival Manager home">
      <img
        src="https://img-cc.sato48.com/sato48/rs:fit:480/plain/s3://sato48-assets/sato48-logo-2026.svg"
        alt="SATO48"
        height="32"
      />
    </NuxtLink>
    <template #append>
      <v-btn
        v-if="impersonating"
        icon="mdi-incognito-off"
        color="error"
        aria-label="Stop masquerading"
        @click="impersonate()"
      />
    </template>
  </v-app-bar>
</template>
